// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__e8x_i","loading":"skeleton_loading__2OVOW"};